(function ($) {

    if (TL.Signin === undefined) {
        TL.Signin = {};
    }


    var facebook = {

        getName() {

            FB.getLoginStatus(function (response) {

                if (response.status === 'connected') {

                    FB.api('/me', function (response) {

                        //Display user signed in    
                        TL.Signin.onSigned(response.name);
                        
                    });
                }
            });
        },

        getInfo() {

            FB.getLoginStatus(function (response) {

                if (response.status === 'connected') {

                    FB.api('/me', function (response) {
                        console.log(JSON.stringify(response));
                    });
                }
            });
        },

        statusChangeCallback(response) {

            // Called with the results from FB.getLoginStatus().
            // The current login status of the person.
            if (response.status === 'connected') {

                // Logged into your webpage and Facebook.                
                TL.Signin.Facebook.facebookSetDataToInput();

            } else {

                // Not logged into your webpage or we are unable to tell.
            }
        },

        facebookSetDataToInput() {

            //Testing Graph API after login.  See statusChangeCallback() for when this call is made.            
            FB.api('/me', function (response) {

                //Submit form
                TL.Signin.Progress.facebookSubmitData('facebook',
                                                        response.id,
                                                        response.name,
                                                        '',
                                                        response.email);
            });
        },

        logout() {

            FB.getLoginStatus(function (response) {

                if (response.status === 'connected') {

                    FB.logout(function (response) {
                        console.log('user is now logged out');
                    });
                }
            });
        }
    }

    if (TL.Signin.Facebook === undefined) {
        TL.Signin.Facebook = facebook;
    }


    window.facebookOnSuccess = function () {

        // Called when a person is finished with the Login Button.
        FB.getLoginStatus(function (response) {

            // See the onlogin handler
            TL.Signin.Facebook.statusChangeCallback(response);
        });
    };
    

    var facebookAsyncInit = function (appId) {

        window.fbAsyncInit = function () {

            FB.init({
                appId: appId,
                cookie: true,       // Enable cookies to allow the server to access the session.
                xfbml: true,        // Parse social plugins on this webpage.
                version: 'v15.0'     // Use this Graph API version for this call.                                
            });
            
            FB.AppEvents.logPageView();           
        }
    };

    if (TL.Signin.Facebook.init === undefined) {
        TL.Signin.Facebook.init = facebookAsyncInit;
    }

})(jQuery);

